// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1Rydl","footer":"ModalFilter_footer__2YZQ8"};